import { render } from "./HandleResponse.vue?vue&type=template&id=a454e12e"
import script from "./HandleResponse.vue?vue&type=script&lang=js"
export * from "./HandleResponse.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Natha\\Documents\\Coding\\TailgatingStack\\AI_tailgating_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__